<template>
	<member-layout
		:modules="modules"
		:active="activeKey"
		:profile="snapshot.profile || {}"
		@change="handleModuleChange"
	>
		<component
			:is="currentComponent"
			:snapshot="snapshot"
			:orders="recentOrders"
			:passengers="passengers"
			:notifications="notifications"
			:account="snapshot.account"
			:coupons="snapshot.coupons"
			:invoices="snapshot.invoices"
			@refresh="handleRefresh"
		/>
	</member-layout>
</template>

<script>
import MemberLayout from './layout/MemberLayout.vue'
import Profile from './modules/Profile.vue'
import Orders from './modules/Orders.vue'
import Passengers from './modules/Passengers.vue'
import Account from './modules/Account.vue'
import Coupons from './modules/Coupons.vue'
import Invoices from './modules/Invoices.vue'
import Notifications from './modules/Notifications.vue'
import Support from './modules/Support.vue'
import Settings from './modules/Settings.vue'
import {
	fetchMemberSnapshot,
	fetchOrders,
	fetchPassengers,
	fetchNotifications
} from './services/memberCenterService'
import { checkLogin, getLogin } from '@/utils/util'
import { isLocal } from '@/utils/yqfCommon'

const MODULES = [
	{ key: 'profile', label: '个人资料', icon: 'el-icon-user' },
	{ key: 'orders', label: '订单管理', icon: 'el-icon-s-order' },
	{ key: 'passengers', label: '常旅客', icon: 'el-icon-user-solid' },
	// { key: 'account', label: '账户资金', icon: 'el-icon-wallet' },
	// { key: 'coupons', label: '优惠券', icon: 'el-icon-gift' },
	// { key: 'invoices', label: '发票管理', icon: 'el-icon-tickets' },
	// { key: 'notifications', label: '消息通知', icon: 'el-icon-bell' },
	// { key: 'support', label: '客服 / 工单', icon: 'el-icon-service' },
	// { key: 'settings', label: '偏好设置', icon: 'el-icon-setting' }
]

const COMPONENT_MAP = {
	profile: Profile,
	orders: Orders,
	passengers: Passengers,
	account: Account,
	coupons: Coupons,
	invoices: Invoices,
	notifications: Notifications,
	support: Support,
	settings: Settings
}

export default {
	name: 'MemberCenterIndex',
	components: {
		MemberLayout
	},
	data() {
		return {
			modules: MODULES,
			activeKey: 'orders',
			snapshot: {
				profile: { initials: 'Y', name: '加载中...' },
				account: {}
			},
			recentOrders: [],
			passengers: [],
			notifications: []
		}
	},
	computed: {
		currentComponent() {
			return COMPONENT_MAP[this.activeKey] || Orders
		}
	},
	watch: {
		'$route.query.section': {
			immediate: true,
			handler(value) {
				if (value && COMPONENT_MAP[value]) {
					this.activeKey = value
				} else if (!value) {
					// 如果没有指定 section，默认显示订单管理
					this.activeKey = 'orders'
				}
			}
		}
	},
	created() {
		// 检查登录状态
		if (!checkLogin()) {
			// 如果是本地环境，允许使用测试账号继续访问
			if (isLocal() || process.env.NODE_ENV === 'development') {
				// 本地环境，使用测试账号，继续初始化数据
				this.bootstrap()
				return
			}
			// 非本地环境且未登录，跳转到登录页面
			const returnurl = encodeURIComponent(window.location.href)
			getLogin(returnurl)
			return
		}
		// 已登录，初始化数据
		this.bootstrap()
	},
	methods: {
		async bootstrap() {
			const [snapshot, orderPayload, passengers, notifications] =
				await Promise.all([
					fetchMemberSnapshot(),
					fetchOrders({ pageSize: 5 }),
					fetchPassengers(),
					fetchNotifications()
				])
			this.snapshot = snapshot
			this.recentOrders = orderPayload.list || []
			this.passengers = passengers
			this.notifications = notifications
		},
		handleModuleChange(key) {
			this.activeKey = key
			this.updateRouteQuery(key)
		},
		updateRouteQuery(section) {
			const current = this.$route.query.section
			if (current === section) {
				return
			}
			this.$router
				.replace({
					path: this.$route.path,
					query: {
						...this.$route.query,
						section
					}
				})
				.catch(() => {})
		},
		// 处理子组件刷新事件
		async handleRefresh() {
			// 如果当前在常旅客页面，刷新常旅客数据
			if (this.activeKey === 'passengers') {
				const passengers = await fetchPassengers()
				this.passengers = passengers
			}
		}
	}
}
</script>

<style lang="scss">
@import '@/style/member-center/index.scss';
</style>

